/** @format */

import React, { FC, useState, useEffect, useMemo } from 'react'
import { _$, Card, Row, Col, Select, Option, Icon, Message } from 'kpc-react'
import styled from 'styled-components'
import variable from 'src/static/styles/var'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { useAsync } from 'react-use'
import { useHistory } from 'react-router-dom'
import Api from 'src/api/ApiCommon'
import ApiCloud from 'src/api/ApiCloud'
import { request } from 'src/utils'
import useGlobalData from 'src/hooks/useGlobalData'
import Collect from 'src/static/images/menu/collect.png'
import Jisuan from 'src/static/images/menu/jisuan.png'
import Hunheyun from 'src/static/images/menu/hunheyun.png'
import Wangluo from 'src/static/images/menu/wangluo.png'
import Shujuku from 'src/static/images/menu/shujuku.png'
import Yunanquan from 'src/static/images/menu/yunanquan.png'
import Cunchu from 'src/static/images/menu/cunchu.png'
import Dashuju from 'src/static/images/menu/dashuju.png'
import Xiaoxiduilie from 'src/static/images/menu/xiaoxiduilie.png'
import Other from 'src/static/images/menu/other.png'

const groupIcon = {
  collect: Collect,
  998: Jisuan,
  997: Wangluo,
  996: Shujuku,
  995: Cunchu,
  994: Dashuju,
  993: Yunanquan,
  992: Xiaoxiduilie,
  991: Hunheyun,
  other: Other
}

const MonitorMenu: FC<any> = ({ className }) => {
  const history = useHistory()
  const [showData, setShowData] = useState<any[]>() // 筛选展示
  const [active, setActive] = useState<string>() // 当前选中组
  const [search, setSearch] = useState<number>() // 搜索内容
  const [collects, setCollects] = useState<number[]>([]) // 我的收藏
  const productOptions = useGlobalData('productMenu')

  // 菜单列表
  const { value: productMenu, loading } = useAsync(async () => {
    const { code, data } = await request(Api.getProductMenu, {})
    if (code === 'Success') {
      return data?.data || []
    }
  }, [])

  // 请求我的收藏
  useAsync(async () => {
    const { code, data } = await request(ApiCloud.getFavorites, {})
    if (code === 'Success') {
      setCollects(data?.data.map(({ productType }) => productType))
    }
  }, [])

  // 筛选展示
  useEffect(() => {
    if (productMenu?.length) {
      if (search || search === 0) {
        // 菜单筛选
        const menu_filter = productMenu.filter(({ subMenus }) => {
          return subMenus.find(({ productType }) => productType === search)
        })
        setActive(menu_filter[0].productType + '')
        setShowData(menu_filter)
      } else {
        setActive('collect')
        setShowData(productMenu)
      }
    } else {
      setShowData([])
    }
  }, [productMenu, search])

  //收藏、取消收藏
  const onCollect = async productType => {
    if (collects.includes(productType)) {
      const { code } = await request(ApiCloud.delFavorites, {
        method: 'post',
        data: {
          productType
        }
      })
      if (code === 'Success') {
        Message.success('取消收藏成功')
        setCollects(collects.filter(item => item !== productType))
      }
    } else {
      if (collects?.length >= 20) {
        Message.warning('云产品收藏个数超过上限20个')
      } else {
        const { code } = await request(ApiCloud.setFavorites, {
          method: 'post',
          data: {
            productType
          }
        })
        if (code === 'Success') {
          Message.success('收藏成功')
          setCollects(collects.concat([productType]))
        }
      }
    }
  }

  // group滚动
  useEffect(() => {
    if (active) {
      const state: any = {
        behavior: 'smooth',
        block: 'start'
      }
      const productElement = document.getElementById(active)
      if (productElement) {
        productElement.scrollIntoView(state)
      }
    }
  }, [active])

  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: '云产品监控' }]} />
      <Card>
        <ul className="left_group">
          <li
            className={active === 'collect' ? 'active' : ''}
            onClick={() => {
              setActive('collect')
            }}
          >
            我的收藏
          </li>
          {showData?.length
            ? showData.map(({ title, productType }) => {
                const className = active === productType + '' ? 'active' : ''
                return (
                  <li
                    className={className}
                    key={productType}
                    onClick={() => {
                      setActive(productType + '')
                    }}
                  >
                    {title}
                  </li>
                )
              })
            : null}
        </ul>
        <div className="right_menu">
          <div className="search">
            <Select
              placeholder="请输入产品名称进行搜索"
              clearable
              size="large"
              value={search}
              filterable
              onChange={value => {
                setSearch(value === '' ? undefined : value)
              }}
            >
              {productOptions?.length
                ? productOptions.map(({ title, productType }) => (
                    <Option key={productType} value={productType}>
                      {title}
                    </Option>
                  ))
                : null}
            </Select>
          </div>
          <div className="menu_list">
            {productOptions?.length ? (
              <div id="collect" className={active === 'collect' ? `menu_item active` : 'menu_item'}>
                <p className="group_title">
                  <img src={groupIcon.collect} width={16} height={16} alt="我的收藏" />
                  <span>我的收藏（{collects?.length}/20）</span>
                </p>
                <Row>
                  {collects?.length ? (
                    collects?.map(product => {
                      const findProduct = productOptions.find(
                        ({ productType }) => product === productType
                      )
                      return findProduct ? (
                        <Col span={6} key={product}>
                          <div className="product">
                            <span
                              onClick={() => {
                                history.push(findProduct.link)
                              }}
                            >
                              {findProduct.title}
                            </span>
                            {collects.includes(product) ? (
                              <Icon
                                className="ion-ios-star"
                                onClick={() => {
                                  onCollect(product)
                                }}
                              />
                            ) : (
                              <Icon
                                className="ion-ios-star-outline"
                                onClick={() => {
                                  onCollect(product)
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      ) : null
                    })
                  ) : (
                    <Col className="null_data" span={6}>
                      -
                    </Col>
                  )}
                </Row>
              </div>
            ) : null}
            {showData?.length
              ? showData.map(({ productType, title, subMenus }) => (
                  <div
                    id={productType + ''}
                    className={active === productType + '' ? `menu_item active` : 'menu_item'}
                    key={productType}
                  >
                    <p className="group_title">
                      <img src={groupIcon[productType]} width={16} height={16} alt={title} />
                      <span>{title}</span>
                    </p>
                    <Row>
                      {subMenus?.map(({ productType, title, link }) =>
                        search === undefined || search === productType ? (
                          <Col span={6} key={productType}>
                            <div className="product">
                              <span
                                onClick={() => {
                                  history.push(link)
                                }}
                              >
                                {title}
                              </span>
                              {collects.includes(productType) ? (
                                <Icon
                                  className="ion-ios-star"
                                  onClick={() => {
                                    onCollect(productType)
                                  }}
                                />
                              ) : (
                                <Icon
                                  className="ion-ios-star-outline"
                                  onClick={() => {
                                    onCollect(productType)
                                  }}
                                />
                              )}
                            </div>
                          </Col>
                        ) : null
                      )}
                    </Row>
                  </div>
                ))
              : null}
          </div>
        </div>
      </Card>
    </div>
  )
}

export default styled(MonitorMenu)`
  .k-card {
    /* height: calc(100vh - 116px); */
    .k-body {
      display: flex;
      padding-top: 0;
      position: relative;
      .left_group {
        width: 200px;
        background: #fff;
        margin-top: 16px;
        li {
          height: 40px;
          padding: 12px 0 12px 16px;
          border-left: 2px solid #e5e5e9;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          &.active {
            border-left: 2px solid ${variable.primaryColor};
            color: ${variable.primaryColor};
          }
        }
      }
      .right_menu {
        width: 100%;
        height: calc(100vh - 132px);
        overflow-y: auto;
        padding: 16px 32px 16px 32px;
        border-left: 1px solid #e5e5e9;
        .search {
          display: flex;
          justify-content: flex-end;
        }
        .menu_list {
          .menu_item {
            padding-bottom: 24px;
            .group_title {
              display: flex;
              align-items: center;
              padding-top: 14px;
              font-size: 14px;
              line-height: 16px;
              transition: all 0.2s ease-in-out;
              span {
                margin-left: 8px;
              }
              /* &.group_icon_collect {
                background: url();
              } */
            }
            .k-row {
              border: 1px solid #e5e5e9;
              border-radius: 3px;
              display: flex;
              flex-wrap: wrap;
              margin-top: 16px;
              padding: 8px 0;
              transition: all 0.2s ease-in-out;
              .k-col {
                padding: 2px 8px;
                .product {
                  display: flex;
                  align-items: center;
                  width: 220px;
                  height: 24px;
                  line-height: 24px;
                  padding: 0 8px;
                  transition: all 0.2s ease-in-out;
                  &:hover {
                    background: #e6f7ff;
                    span {
                      color: ${variable.primaryColor};
                    }
                    .k-icon {
                      opacity: 1;
                    }
                  }
                  span {
                    cursor: pointer;
                    margin-bottom: 0;
                    line-height: 18px;
                    font-size: 12px;
                    transition: all 0.2s ease-in-out;
                  }
                  .k-icon {
                    transition: all 0.2s ease-in-out;
                    opacity: 0;
                    cursor: pointer;
                    margin-left: 8px;
                    margin-top: -2px;
                    &.ion-ios-star {
                      color: #ff9a05;
                    }
                  }
                }
                &.null_data {
                  font-size: 14px;
                  padding-left: 16px;
                }
              }
            }
            &.active {
              .group_title {
                color: ${variable.primaryColor};
              }
              .k-row {
                border: 1px solid ${variable.primaryColor};
              }
            }
          }
        }
      }
    }
  }
`
